import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Set default Authorization header if user is authenticated
const token = localStorage.getItem('TOKEN') || sessionStorage.getItem('TOKEN');
if (token) {
    axios.defaults.headers.common['Authorization'] = `Token ${token}`;
}

// Inject KaTeX CSS
const katexCSS = document.createElement('link');
katexCSS.rel = 'stylesheet';
katexCSS.href = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css';
katexCSS.integrity = 'sha384-n8MVd4RsNIU0tAv4ct0nTaAbDJwPJzDEaqSD1odI+WdtXRGWt2kTvGFasHpSy3SV';
katexCSS.crossOrigin = 'anonymous';
document.head.appendChild(katexCSS);

ReactDOM.render(<App />, document.getElementById('root'));

// Optional: enable service worker
serviceWorker.unregister();
